<template>
  <div class="w-100">
    <form ref="form" v-kendo-validator novalidate>
      <div class="page-header d-flex w-100">
        <div class="title-col d-flex w-50">
          <!-- <span class="title-icon">
            <span class="nt-people-fill"></span>
          </span>-->
          <span class="title-text database-details-text">Database Details</span>
        </div>
        <!-- <div class="text-right ml-auto">
          <button
            class="k-button k-primary ml-2"
            type="button"
            @click="save"
            v-if="!readOnly&&database.id"
          >Save</button>
        </div>-->
      </div>
      <div class="form-group radio-button-div"  style="min-width: 1000px;
      max-width: 1500px;">
        <input id="for-default" type="radio" :checked="checkedToggle('default')" name="dbConfig" :disabled="toggleDisable" @click="toggleDbConfig('default')"/>
        <label class="db-label" for="for-default">Default DB</label>

        <input id="for-dedicated" type="radio" :checked="checkedToggle('dedicated')" class="ml-5" name="dbConfig" :disabled="toggleDisable" @click="toggleDbConfig('dedicated')"/>
        <label class="db-label" for="for-dedicated">Dedicated DB</label>
      </div>
      <div class="page-body">
        <div>
          <div>
              <button
                v-if="!readOnly"
                class="k-button k-primary ml-2 text-right"
                type="button"
                @click="create"
              >Create a new Configuration</button>
            </div>
            <!-- <kendo-dropdownlist
                v-model="database"
                :data-source="sharedProfiles"
                :data-text-field="'name'"
                :data-item-key="'id'"
                :data-value-field="'id'"
                :required="true"
                class="w-100"
                :disabled="readOnly"
              ></kendo-dropdownlist>-->
            <div class="form-group">
              <label>Database Configuration</label>
              <dropdownlist
                v-model="database"
                :data-items="sharedProfiles"
                :text-field="'name'"
                :item-key="'id'"
                :data-value-field="'id'"
                :required="true"
                class="w-100"
                :disabled="readOnly"
              ></dropdownlist>
            </div>
          <!-- <div v-if="useSharedDb"> -->
            <div class="form-group">
              <b-table sticky-header v-if="configValue" :fields="fields" :items="database.configDBDetail">
                <template v-if="database.id" v-slot:cell(microserviceName)="config">{{config.item.microserviceName}}</template>
                <template v-slot:cell(connectionString)="config">
                  <k-input
                    type="text"
                    class="w-100"
                    style="width:5em"
                    :value="config.item.connectionString"
                    v-on:input="setConnection($event,config.item)"
                    :disabled="readOnly"
                  />
                </template>
                <template v-slot:cell(test)="config">
                  <kendo-button @click="testConnection(config)" type="button">Test Connection</kendo-button>
                </template>
              </b-table>
            </div>

            
          <!-- </div> -->

          <!-- <div class="form-group radio-button-div">
            <input
              id="for-default"
              type="radio"
              name="dbConfig"
              v-model="database"
              value="default"
            />
            <label class="db-label" for="for-default">Default DB</label>

            <input
              id="for-dedicated"
              type="radio"
              class="ml-5"
              name="dbConfig"
              v-model="database"
              value="dedicated"
            />
            <label class="db-label" for="for-dedicated">Dedicated DB</label>
          </div>-->
          <div class="form-group">
            <b-table sticky-header v-if="!configValue" :fields="sharedDBFields" :items="database.configDBDetail"></b-table>
          </div>
        </div>
      </div>
      <!-- <div class="buttons text-right">
        <button type="button" class="save-button btn btn-primary ml-3 rounded-border"  @click="save">Save</button> -->
          <!-- <button type="button" style="color: #0047b2;" class="save-button btn ml-3 rounded-border" @click="activate">Save & Activate</button> -->
          <!-- <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3" @click="close">Cancel</button> -->
      <!-- </div> -->
    </form>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import { createNamespacedHelpers } from "vuex";
import { notifyApiError, notify } from "../../utils/notification-helper";
const { mapActions,mapState, mapMutations } = createNamespacedHelpers("onboarding");
export default {
  props: ["readOnly","tenantData"],
  data: function() {
    return {
      fields: [
        { key: "microserviceName", sortable: true },
        { key: "connectionString" },
        { key: "test" }
      ],
      configValue: false,
      // selected: null
    };
  },
  methods: {
    ...mapActions(["saveDatabase", "createProfileConfig", "testConnection","activateTenant","resetState"]),
    ...mapMutations(["setConnectionString"]),
    save: function() {
      this.saveDatabase()
        .then(message => {
          notify(message);
          this.canContinue();
        })
        .catch(notifyApiError);
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
    },
    setConnection(event, item) {
      this.setConnectionString({ item, value: event.target.value });
    },
    create() {
      // let data = this.tenantData.kendoValidator.element[0][0].value;
      this.createProfileConfig();
    },
    activate() {
      this.activateTenant()
        .then(message => {
          notify(message);
          this.resetState();
          this.$store.dispatch("loadTenants", null, { root: true });
          this.$router.push("/add-tenant");
        })
        .catch(notifyApiError);
    },
    toggleDbConfig(type) {
      if(type == 'default') {
        this.configValue = false;
        this.tenant.useSharedDb = true;
      } else if(type == 'dedicated') {
        this.configValue = true;
        this.tenant.useSharedDb = false;
      }
    },
    checkedToggle(type) {
      return type == 'default' && this.tenant.useSharedDb == true ? true : type == 'dedicated' && this.tenant.useSharedDb == false ? true : false;
    }
  },
  computed: {
    ...mapFields([
      "onboarding.database",
      "onboarding.database.provider",
      "onboarding.tenant.useSharedDb",
      "onboarding.database.name",
      "onboarding.database.description",
      "onboarding.database.connectionString",
      
    ]),
    ...mapState(["onboarding.database","sharedProfiles","tenant","editField"]),
    ...mapMultiRowFields(["onboarding.database.configDBDetail"]),
    sharedDBFields() {
      return this.fields.filter(f => f.key !== "test");
    },
    toggleDisable() {
      return this.editField;
    },
  }, 
};
</script>

<style>
.database-details-text {
  color: #777777;
}

.page-header {
  margin-top: 20px;
}

.radio-button-div {
  margin-top: 8px;
  vertical-align: middle;
}

input[type="radio"] {
  margin-right: 3px;
  height: 15px;
  width: 15px;
}

.form-group label.db-label {
  font-size: 14px;
  color: #777;
}
</style>